import React, { useState, useEffect, useCallback, memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CountDown from '../CountDown';
import Traductor from '../Traductor';
import Button from '../bronson/Button';
import { formatDate } from '../../Functions';
import '../../css/components/auctions/AuctionCard.css';
import Globals from '../../Globals';
import { checkAuctionIsActive } from '../../js/components/shared/vehicleFunctions';
import NoImagePNG from '../../images/no-image.png';
import { isAppleDeviceOrNavegatorForDates } from '../../Functions';
import Tag from '../bronson/Tag';

import * as filtersActions from '../../redux/actions/filters';
import * as closedBatchActions from '../../redux/actions/closedBatches';

const AuctionCard = ({
    item,
    history,
    type,
    serverTime,
    setFilters: setReduxFilters,
    reduxInitialFilters,
    selectClosedBatch,
}) => {
    const t = useMemo(() => new Traductor(), []);
    const [auctionEnd, setAuctionEnd] = useState(false);

    const options = {
        text: t.getTraduction(
            item.EsLoteCerrado ? 'SeeClosedBatch' : 'IrASubasta'
        ),
        btnTypes: ['link'],
        class: 'c-btn--small',
        icon: {
            image: 'semantic-forward',
            title: t.getTraduction(
                item.EsLoteCerrado ? 'SeeClosedBatch' : 'IrASubasta'
            ),
            isBeforeText: true,
        },
    };

    useEffect(() => {
        if (!serverTime) return;
        if (type === 'active') {
            setAuctionEnd(
                !checkAuctionIsActive(
                    isAppleDeviceOrNavegatorForDates(item.StartDate),
                    isAppleDeviceOrNavegatorForDates(
                        item.EsLoteCerrado
                            ? item.EndDate
                            : item.EndDateWithExtension
                    ),
                    serverTime
                )
            );
        } else if (type === 'upcoming') {
            const upcomingDate = new Date(
                isAppleDeviceOrNavegatorForDates(item.StartDate)
            );
            setAuctionEnd(
                !checkAuctionIsActive(
                    upcomingDate.setHours(upcomingDate.getHours() - 1),
                    isAppleDeviceOrNavegatorForDates(item.EndDate),
                    serverTime,
                    true
                )
            );
        }
    }, [
        serverTime,
        type,
        item.EndDate,
        item.StartDate,
        item.EsLoteCerrado,
        item.EndDateWithExtension,
    ]);

    const routeToAgrupacion = useCallback(() => {
        if (!auctionEnd) {
            if (item.EsLoteCerrado) {
                selectClosedBatch(item.LotId);
                localStorage.setItem(
                    'selectedClosedBatchDetails',
                    JSON.stringify(item)
                );
                return history.push({
                    pathname: `${Globals.APPLICATION_PATH.CLOSED_BATCH}/${item.AgrupationVersion}`,
                });
            }

            if (type === 'active') {
                setReduxFilters({
                    ...reduxInitialFilters,
                    filterAgrupations: [item.AgrupationVersion],
                    filterFavorite: false,
                    filterBidden: false,
                });
                history.push({
                    pathname: Globals.APPLICATION_PATH.AUCTION,
                });
            } else if (type === 'upcoming') {
                setReduxFilters({
                    ...reduxInitialFilters,
                    filterAgrupations: [item.AgrupationVersion],
                    upcomingAgrupation: item.AgrupationVersion,
                    filterFavorite: false,
                    filterBidden: false,
                });
                history.push({
                    pathname: Globals.APPLICATION_PATH.AUCTION,
                });
            }
        }
    }, [
        auctionEnd,
        history,
        item,
        reduxInitialFilters,
        selectClosedBatch,
        setReduxFilters,
        type,
    ]);

    const printImage = useCallback(() => {
        if (!item.ImageSource)
            return <img src={NoImagePNG} sizes="100vw" alt="Imagen subasta" />;

        return (
            <div style={{ position: 'relative' }}>
                <img
                    src={process.env.PUBLIC_URL + item.ImageSource}
                    sizes="100vw"
                    alt="Imagen subasta"
                />
                {item.AmountMax && !item.Sold ? (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '4px',
                            right: '4px',
                        }}
                    >
                        <Tag
                            classes={[
                                'c-vehicle-card__tag-bid',
                                item.AmountMax === item.Amount
                                    ? 'success'
                                    : 'error',
                            ]}
                            text={
                                item.AmountMax === item.Amount
                                    ? t.getTraduction('WinningBid')
                                    : t.getTraduction('BidExceeded')
                            }
                        />
                    </div>
                ) : null}
            </div>
        );
        //}
    }, [item, t]);

    const getCountDown = useCallback(() => {
        return (
            <div className="o-layout__item  u-1/1 u-mt-mini">
                <p className="u-mb-none skeleton-title">
                    {type === 'active'
                        ? t.getTraduction('FinalizaEn')
                        : t.getTraduction('EmpiezaEn')}
                </p>
                {item.skeleton ? (
                    <p className="u-h3 u-mb-none skeleton-body"></p>
                ) : (
                    <p className="u-h6 u-font-initial u-mb-none">
                        <CountDown
                            dateTime={
                                type === 'active'
                                    ? item.EndDate
                                    : item.StartDate
                            }
                            isFinishedParent={setAuctionEnd}
                            dateExtended={item.EndDateWithExtension}
                            serverTime={serverTime}
                        />
                    </p>
                )}
            </div>
        );
    }, [
        item.EndDate,
        item.EndDateWithExtension,
        item.StartDate,
        item.skeleton,
        serverTime,
        t,
        type,
    ]);

    const printVehiclesNumber = useCallback(() => {
        if (item.skeleton) return null;
        return item.NumberOfCars > 1
            ? t.getTraduction('Vehicles')
            : t.getTraduction('Vehicle');
    }, [item.NumberOfCars, item.skeleton, t]);

    const getCardClasses = useCallback(() => {
        let classes = '';
        classes += item.skeleton ? 'skeleton ' : '';
        classes += auctionEnd || item.Sold ? 'c-card--inactive' : ''; //closed batch sold -> item.Sold
        return classes;
    }, [auctionEnd, item.Sold, item.skeleton]);

    return (
        <article
            className={'c-card c-card--auction ' + getCardClasses()}
            onClick={routeToAgrupacion}
        >
            <header className="c-card__header u-p u-pb-none">
                <p className="u-h5 c-card__title u-mb-small">{item.Name}</p>
                {printImage()}
            </header>
            <div className="c-card__body u-p u-pb-none">
                {item.Sold && (
                    <p className="c-watermark-text">
                        {t.getTraduction('Sold')}
                    </p>
                )}
                <div className="o-layout">
                    <div className="o-layout__item u-1/1 u-mt-none">
                        <p className="u-mt u-mb-none skeleton-body">
                            <span className="u-h3">
                                {item.NumberOfCars + ' '}
                            </span>
                            <span className="u-h6 u-font-initial skeleton-body">
                                {printVehiclesNumber()}
                            </span>
                        </p>
                    </div>
                    {getCountDown()}
                    <div className="o-layout__item u-1/2 u-mt-mini">
                        <p className="u-text-disabled u-mb-none skeleton-title">
                            {t.getTraduction('FechaInicio')}
                        </p>
                        <p className="skeleton-body">
                            {formatDate(
                                isAppleDeviceOrNavegatorForDates(
                                    item.StartDate
                                ),
                                true
                            )}
                        </p>
                    </div>
                    <div className="o-layout__item u-1/2 u-mt-mini">
                        <p className="u-text-disabled u-mb-none skeleton-title">
                            {t.getTraduction('FechaFin')}
                        </p>
                        <p className="skeleton-body">
                            {formatDate(
                                isAppleDeviceOrNavegatorForDates(item.EndDate),
                                true
                            )}
                        </p>
                    </div>
                </div>
            </div>
            <footer className="c-card__footer u-p">
                <Button options={options} onClick={routeToAgrupacion} />
            </footer>
        </article>
    );
};

const mapStateToProps = state => ({
    reduxInitialFilters:
        state.filters[Globals.APPLICATION_PATH.AUCTION].initial,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...bindActionCreators(
        { ...filtersActions, ...closedBatchActions },
        args => {
            //inject key with page route to actions
            return dispatch({
                ...args,
                route: Globals.APPLICATION_PATH.AUCTION,
            });
        }
    ),
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(AuctionCard));
